import './basePage.scss';

import * as React from 'react';

import {Navbar} from '../Navbar';
import {Title} from './Title';
import {Icon} from '../Icon';
import {SweetAlert} from '../SweetAlert';
import {hideAlert} from '../../../actions/miscellaneousActions';
import {FooterBar} from '../Footer';

export interface IBasePageProps {
    icon?: string;
    title: string;
    baseClassName?: string;
    pic?: string;
    className?: string;
    sideButton?: JSX.Element | JSX.Element[];
}

export class BasePage extends React.PureComponent<IBasePageProps, {}> {
    constructor(props: IBasePageProps) {
        super(props);
    }

    public componentDidMount() {
        document.title = this.props.title;
    }

    public componentWillUpdate(nextProps: IBasePageProps) {
        document.title = nextProps.title;
    }

    public componentWillMount() {
        hideAlert();
    }

    public render() {
    const {children, title, icon, baseClassName, sideButton} = this.props;
    return <div className={`base-page ${baseClassName}`}>
        <Navbar/>
        <SweetAlert/>
        <div className="basepage-container">
            <div className="basepage-header">
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    width: '100%',
                    position: 'relative'
                }}>
                    <div style={{ minWidth: '60px' }} />
                    
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1
                    }}>
                        {this.props.icon ? <Icon icon={icon} size="3x"/> : ''}
                        {this.props.pic ? <div className="display-image"><img src={this.props.pic}/></div> : ''}
                        &nbsp; &nbsp;
                        <Title>{title || 'Loading...'}</Title>
                    </div>
                    
                    {sideButton && (
                        <div style={{ marginRight: '20px' }}>
                            {sideButton}
                        </div>
                    )}
                </div>
            </div>
            <hr/>
            <div className={`child ${this.props.className}`}>
                {children}
            </div>
        </div>
        <FooterBar/>
    </div>;
}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/BasePage/index.tsx